<template>
  <div class="padding-12 radius" :class="customClass" @click="onClick">
    <div class="flex align-center justify-between">
      <div>
        <span class="text-grey1"> {{ $moment(data.predictArriveOriginTime).format("YYYY-MM-DD HH:mm") }}</span>
        <van-tag
          class="margin-left-4"
          plain
          color="#999999"
          v-if="data.orderStatus === -1"
          >已取消</van-tag
        >
        <van-tag
          class="margin-left-4"
          plain
          color="#08a34d"
          v-if="data.orderStatus === 1"
          >行程中</van-tag
        >
        <van-tag
          class="margin-left-4"
          plain
          color="#08a34d"
          v-if="data.orderStatus === 2"
          >已完成</van-tag
        >
        <van-tag
          class="margin-left-4"
          plain
          color="#08a34d"
          v-if="data.orderStatus === 3"
          >待出行</van-tag
        >
      </div>
      <div>
        <span class="text-yellow" v-if="data.status === 'processing'">客服处理中</span>
        <span class="text-green" v-if="data.status === 'ok'">完成</span>
      </div>
    </div>
    <div class="padding-tb-12 border-bottom text-grey1">
      <div class="text-grey text-12 padding-left-12 margin-bottom-12 ball ball-from">
        {{ data.startAddress }}
      </div>
      <div class="text-grey text-12 padding-left-12 ball ball-to">
        {{ data.endAddress }}
      </div>
    </div>

    <div class="flex justify-between align-center text-grey1 padding-top-12">
      <div>订单号：{{ data.orderId }}</div>
      <div>
        <span class="text-12 border padding-2" v-if="data.channel === 'platform'">申请平台介入</span>
        <span class="text-12 border padding-2" v-if="data.channel === 'complain'">订单投诉</span>
        <span class="text-12 border padding-2" v-if="data.channel === 'suggest'">意见反馈</span>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Tag } from 'vant'

Vue.use(Tag)
export default {
  props: {
    customClass: {
      type: Array,
      default: () => []
    },
    data: {
      type: Object,
      require: true
    },
    showComplaint: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    onClick () {
      this.$emit('click', this.data)
    }
  }
}
</script>

<style lang="scss" scoped>
.ball {
  position: relative;
  &::before {
    content: "";
    position: absolute;
    width: 5px;
    height: 5px;
    left: 1px;
    top: 50%;
    margin-top: -4px;
    border-radius: 50%;
  }
}
.ball-from {
  &::before {
    background-color: $primary;
  }
}
.ball-to {
  &::before {
    background-color: $green;
  }
}
</style>
